import { render, staticRenderFns } from "./CreateGroupPopup.vue?vue&type=template&id=303432bc&scoped=true"
import script from "./CreateGroupPopup.vue?vue&type=script&lang=js"
export * from "./CreateGroupPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303432bc",
  null
  
)

export default component.exports